import { render, staticRenderFns } from "./NewsAndNoticeShow.vue?vue&type=template&id=305fdb21&"
import script from "./NewsAndNoticeShow.vue?vue&type=script&lang=js&"
export * from "./NewsAndNoticeShow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports